import { User } from "lucide-react";
import React from "react";

type AvatarSize = "xxxs" | "xxs" | "xs" | "sm" | "md" | "lg" | "xl";

interface DefaultAvatarProps {
  userId: string;
  displayName?: string; 
  size?: AvatarSize; 
}

// Adjusted map to include typography sizes
const sizeMap: Record<AvatarSize, string> = {
  xxxs: "w-6 h-6 text-[10px]",     // 24px
  xxs: "w-8 h-8 text-xs",          // 32px
  xs: "w-10 h-10 text-sm",         // 40px
  sm: "w-12 h-12 text-base",       // 48px
  md: "w-20 h-20 text-2xl",        // 80px
  lg: "w-32 h-32 text-4xl",        // 128px
  xl: "w-48 h-48 text-6xl",        // 192px
};

const getInitials = (name: string): string => {
  if (!name || name.trim().length === 0) return "?";
  const parts = name.trim().split(" ");
  if (parts.length === 1) return parts[0][0]?.toUpperCase() ?? "?";
  return (parts[0][0] + (parts[1]?.[0] || '')).toUpperCase();
};

const DefaultAvatar: React.FC<DefaultAvatarProps> = ({
  displayName,
  size = "md",
}) => {
  // Graceful fallback to "U" for Unknown if no display name is passed
  const nameToUse = displayName || "Unknown";
  void (getInitials(nameToUse));
  const sizeClasses = sizeMap[size] || sizeMap.md;

  return (
    <div
      className={`default-avatar flex items-center justify-center rounded-full shrink-0 font-medium font-poppins bg-[#7E57C2]/10 text-[#7E57C2] border border-[#7E57C2]/20 ${sizeClasses}`}
      // title={displayName}
    >
      <User/>
    </div>
  );
};

export default DefaultAvatar;
